<template>
  <v-select
    v-model="selected"
    return-object
    :items="sortingOptions"
    item-text="text"
    item-value="value"
    :hide-details="true"
    dense
    outlined
    rounded
    append-icon="icon-arrow-down"
    full-width
    :prefix="`${$t('message.common.sort')}:`"
    :menu-props="{
      contentClass: 'facilities-sorting-option-select__menu',
      offsetY: true
    }"
    class="facilities-sorting-option-select"
    @input="setSortingOption"
  >
  </v-select>
</template>

<script>
import { FACILITIES_SORTING_OPTION } from "@/enums/facilities-sorting-option";

export default {
  name: "ListingsConfigurationFacilitiesSortingSelect",
  data() {
    return {
      selected: {}
    };
  },
  created() {
    this.selected = this.sortingOptions.length ? this.sortingOptions[0] : {};
  },
  computed: {
    sortingOptions() {
      return Object.values(FACILITIES_SORTING_OPTION).map(v => {
        return {
          text: this.$t(`message.facilitiesSortingOptions.${v}`),
          value: v
        };
      });
    }
  },
  methods: {
    setSortingOption(sortingOption) {
      this.$emit("update", sortingOption.value);
    }
  }
};
</script>

<style lang="scss" src="./FacilitiesSelect.scss"></style>
